/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ errorType: NonNullable<unknown> }} Error_Nav_No_Filtered_ErrorsInputs */



/**
* | output |
* | --- |
* | "No {errorType} errors found for this event." |
*
* @param {Error_Nav_No_Filtered_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_filtered_errors = /** @type {((inputs: Error_Nav_No_Filtered_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Filtered_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucune erreur ${i?.errorType} trouvee pour cet evenement.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Für dieses Ereignis wurden keine ${i?.errorType}-Fehler gefunden.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Nessun errore ${i?.errorType} trovato per questo evento.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Для данного события ошибок ${i?.errorType} не обнаружено.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se encontraron errores ${i?.errorType} para este evento.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`此事件未发现 ${i?.errorType} 错误。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`このイベントには${i?.errorType} エラーは見つかりませんでした。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इस इवेंट के लिए कोई ${i?.errorType} त्रुटि नहीं पाई गई।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Nenhum erro ${i?.errorType} foi encontrado para este evento.`)
	return /** @type {LocalizedString} */ (`No ${i?.errorType} errors found for this event.`)
});